import { render, staticRenderFns } from "./About-Us.vue?vue&type=template&id=b7162138&"
import script from "./About-Us.vue?vue&type=script&lang=js&"
export * from "./About-Us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports